import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xml",
  "use": "icon-xml-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xml\"><path fill=\"#333333\" d=\"M10.24 453.632L295.936 153.6v152.576l-194.56 197.632v2.048l193.536 197.632v152.576L10.24 555.008v-101.376zM548.864 76.8H624.64l-147.456 870.4h-73.728c-1.024 0 145.408-870.4 145.408-870.4z m179.2 627.712L921.6 506.88v-2.048L728.064 308.224V155.648L1013.76 456.704v105.472L728.064 861.184V704.512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol